import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class FishingVillageBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.FISHING_VILLAGE;
}

export default FishingVillageBuildingTileEntity;
